import { render } from "./BlockHalfContentHalfMedia.vue?vue&type=template&id=2a95e3c0&scoped=true"
import script from "./BlockHalfContentHalfMedia.vue?vue&type=script&lang=js"
export * from "./BlockHalfContentHalfMedia.vue?vue&type=script&lang=js"

import "./BlockHalfContentHalfMedia.vue?vue&type=style&index=0&id=2a95e3c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a95e3c0"]])

export default __exports__